<template>
  <div class="flex shrink-0 border-t border-white/10 p-2">
    <nav class="flex flex-col gap-1 px-2">
      <button
        :class="[small ? 'text-sm' : 'text-base']"
        class="w-full text-fp-green-1 hover:bg-fp-green-7/75 group flex items-center px-2 py-2 font-medium rounded-md"
        @click="signOut({ external: true })"
      >
        Logout
      </button>
    </nav>
  </div>
</template>

<script lang="ts" setup>
const { signOut } = useAuth()

defineProps({
  small: {
    type: Boolean,
    default: false,
  },
})
</script>
